import { isSupportedLocale, type Locale } from "./locales";

const COOKIE_NAME = "zoey_locale";
const ONE_YEAR = 60 * 60 * 24 * 365;

export function readLocaleCookie(): Locale | null {
  if (typeof document === "undefined") return null;
  for (const part of document.cookie.split(";")) {
    const [k, v] = part.trim().split("=");
    if (k === COOKIE_NAME && isSupportedLocale(v)) return v;
  }
  return null;
}

export function writeLocaleCookie(locale: Locale): void {
  if (typeof document === "undefined") return;
  const secure = location.protocol === "https:" ? "; Secure" : "";
  document.cookie =
    `${COOKIE_NAME}=${locale}; Max-Age=${ONE_YEAR}; Path=/; SameSite=Lax${secure}`;
}
